import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZelleComponent } from './simple-icons-zelle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZelleComponent ],
    exports:      [ SimpleIconsZelleComponent ],
    bootstrap:    []
})
export class SimpleIconsZelleModule {}
